import { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Lenis from "lenis";

gsap.registerPlugin(ScrollTrigger);

export const reducedMotion = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches;

let lenis = null;

export function startSmoothScroll() {
  if (lenis || reducedMotion()) return;
  lenis = new Lenis({ lerp: 0.11, smoothWheel: true });
  lenis.on("scroll", ScrollTrigger.update);
  gsap.ticker.add((t) => lenis.raf(t * 1000));
  gsap.ticker.lagSmoothing(0);
}

export const getLenis = () => lenis;

export function scrollToTop() {
  if (lenis) lenis.scrollTo(0, { immediate: true });
  else window.scrollTo(0, 0);
}

export function useReveal() {
  useEffect(() => {
    const root = document.getElementById("main") || document.body;
    const pending = () => [...document.querySelectorAll("[data-reveal]:not(.is-in):not([data-seen])")];
    if (reducedMotion() || !("IntersectionObserver" in window)) {
      const showAll = () => pending().forEach((e) => e.classList.add("is-in"));
      showAll();
      const mo = new MutationObserver(showAll);
      mo.observe(root, { childList: true, subtree: true });
      return () => mo.disconnect();
    }
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add("is-in");
          io.unobserve(e.target);
        }
      }),
      { rootMargin: "0px 0px -6% 0px", threshold: 0.06 },
    );
    const scan = () => pending().forEach((e) => { e.setAttribute("data-seen", ""); io.observe(e); });
    scan();
    const mo = new MutationObserver(scan);
    mo.observe(root, { childList: true, subtree: true });
    return () => {
      mo.disconnect(); io.disconnect();
      document.querySelectorAll("[data-reveal][data-seen]:not(.is-in)").forEach((e) => e.removeAttribute("data-seen"));
    };
  }, []);
}

export { gsap, ScrollTrigger };
